/**
 * B2B Price Block — Variantenwechsel Handler
 * Turbo Theme 9.3.0
 *
 * Turbo feuert KEINEN custom variant-event.
 * Stattdessen: change-Event auf select#product-select-*
 * Variantenpreis wird aus ShopifyAnalytics.meta.product geholt.
 */

(function () {
  'use strict';

  // Geldformat aus Turbo holen
  function getMoneyFormat() {
    if (window.theme && window.theme.moneyFormat) {
      return window.theme.moneyFormat;
    }
    return '\u20ac{{amount_with_comma_separator}}';
  }

  // Cent-Betrag formatieren
  function formatMoney(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var amount      = (cents / 100).toFixed(2);
    var amountComma = amount.replace('.', ',');
    return format
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.floor(cents / 100))
      .replace('{{amount_no_decimals}}', Math.floor(cents / 100))
      .replace('{{amount}}', amount);
  }

  // Alle B2B-Blöcke auf der Seite mit neuem Variantenpreis aktualisieren
  function updateAllB2BBlocks(variantPrice) {
    var blocks = document.querySelectorAll('[id^="b2b-price-block-"]');
    if (!blocks.length) return;

    var format = getMoneyFormat();

    blocks.forEach(function (block) {
      var discount = parseInt(block.getAttribute('data-b2b-discount'), 10);
      if (!discount || discount <= 0) return;

      var b2bCents     = Math.floor(variantPrice * (100 - discount) / 100);
      var savingsCents = variantPrice - b2bCents;

      block.setAttribute('data-original-price', variantPrice);
      block.setAttribute('data-b2b-price',      b2bCents);

      var b2bEl    = block.querySelector('.b2b-price-block__amount--b2b');
      var origEl   = block.querySelector('.b2b-price-block__amount--original s');
      var savingsEl = block.querySelector('.b2b-price-block__savings-amount');

      if (b2bEl)     b2bEl.textContent     = formatMoney(b2bCents,     format);
      if (origEl)    origEl.textContent    = formatMoney(variantPrice,  format);
      if (savingsEl) savingsEl.textContent = formatMoney(savingsCents,  format);
    });
  }

  // Variantenpreis aus ShopifyAnalytics.meta.product anhand der ID ermitteln
  function getPriceFromVariantId(variantId) {
    try {
      var product = window.ShopifyAnalytics
        && window.ShopifyAnalytics.meta
        && window.ShopifyAnalytics.meta.product;

      if (!product || !product.variants) return null;

      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        // ID kann String oder Number sein
        if (String(v.id) === String(variantId)) {
          // Preis ist in ShopifyAnalytics in Cent (integer)
          return typeof v.price === 'number' ? v.price : parseInt(v.price, 10);
        }
      }
    } catch (e) {
      console.warn('B2B: Fehler beim Preislesen', e);
    }
    return null;
  }

  // Change-Event auf Varianten-Select abfangen
  function bindVariantSelect() {
    // Turbo rendert den Select mit id="product-select-SECTIONID--TEMPLATEID"
    var selects = document.querySelectorAll('select[id*="product-select"]');

    selects.forEach(function (sel) {
      sel.addEventListener('change', function (e) {
        var variantId = e.target.value;
        if (!variantId) return;

        // Kleines Timeout damit ShopifyAnalytics.meta.selectedVariantId
        // bereits aktualisiert ist bevor wir lesen
        setTimeout(function () {
          var price = getPriceFromVariantId(variantId);
          if (price !== null) {
            updateAllB2BBlocks(price);
          }
        }, 50);
      });
    });
  }

  // Initialisierung sobald DOM bereit
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindVariantSelect);
  } else {
    bindVariantSelect();
  }

})();